import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import styled from 'styled-components/native';
import { SafeAreaView, TouchableOpacity, View, StyleSheet } from 'react-native';
import { FlexBlock, FlexElement, Heading4, StatBlock, MetricStackTitle, ShinyBlockOuter, ShinyBody, ShinyHeading, BasicText as Text, ExtraStyles, Heading } from '../../Styles';
import Icon from '../../core/Icon';
import Modal from '../../core/Modal';
import ServiceRequest from './ServiceRequest';
import { COLORS } from '../../../WasteTheme';
import Util from '../../core/Util';

const InfoBlock = ({children, weight = "bold", heading = undefined}) => {
    return <View style={{justifyContent: "flex-start", width: "48%", flexWrap: "wrap"}}>
        {heading != undefined? <Heading4 weight={weight}>{heading}</Heading4> : null}
        {children}
    </View>
}

const SiteInfo = ({site, client, services, jumpToSchedule = undefined, supportAccess = false}) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    useEffect(()=>{
        if(modalVisible == false){
            setModalContent(null);
        }
    }, [modalVisible]);

    const requestPickup = () => {
        setModalContent(<ServiceRequest allServices={services} siteId={site.site_id} />);
        setModalVisible(true);
    };

    const jump = () => {
        jumpToSchedule();
    };

    const blockWrapperStyle = {flexDirection: "row", flexWrap: "wrap", justifyContent: "space-between"};

    return <ShinyBlockOuter flexBasis={Util.isMobile()? "100%": "99%"} style={{marginHorizontal: 0}}>
        <ShinyHeading>
            <MetricStackTitle>Info</MetricStackTitle>
        </ShinyHeading>
        <ShinyBody style={{height: "90%"}}>
            <Modal modalVisible={modalVisible} setModalVisible={setModalVisible}>
                {modalContent}
            </Modal>
            <View style={{flexDirection: "row", height: "100%", justifyContent: "space-between", flexWrap: "wrap"}}>
                <View style={{flexDirection: "column", justifyContent: "space-between", flexGrow: 1}}>
                    <View style={blockWrapperStyle}>
                        <InfoBlock heading="Client">
                            <Text>{client.client_name}</Text>
                        </InfoBlock>
                        <InfoBlock heading="Site">
                            <Text>{site.name}</Text>
                        </InfoBlock>
                    </View>
                    <View style={blockWrapperStyle}>
                        <InfoBlock heading="Site Contact">
                            <Text>{site.primary_contact_names}</Text>
                        </InfoBlock>
                        <InfoBlock heading="Contact Email">
                            <Text>{site.primary_contact_emails}</Text>
                        </InfoBlock>
                    </View>
                    <View style={blockWrapperStyle}>
                        <InfoBlock heading="City">
                            <Text>{site.city}</Text>
                        </InfoBlock>
                        <InfoBlock heading="Province">
                            <Text>{site.province}</Text>
                        </InfoBlock>
                    </View>
                    <View style={blockWrapperStyle}>
                        <InfoBlock heading="Address">
                            <Text>{site.address}</Text>
                        </InfoBlock>
                    </View>
                </View>
                <View style={{flexDirection: "column", justifyContent: "space-between", height: 115, marginTop: 10}}>
                    {supportAccess == true?
                    <TouchableOpacity onPress={()=>requestPickup()} style={[ExtraStyles.buttonLight, ExtraStyles.blueButton, {width: 185}]}>
                        <Icon icon="dumpster"/>
                        <Text style={{whiteSpace: "nowrap"}}>Request Service</Text>
                        <Icon icon="long-arrow-right" size={15}/>
                    </TouchableOpacity>
                    : null}
                    {Util.isMobile()? 
                        null : 
                        <TouchableOpacity onPress={()=>jump()} style={[ExtraStyles.buttonLight, ExtraStyles.blueButton, {width: 185}]}>
                            <Icon icon="calendar"/>
                            <Text>Schedule</Text>
                            <Icon icon="long-arrow-down" size={15}/>
                        </TouchableOpacity>
                    }
                </View>
            </View>
        </ShinyBody>
    </ShinyBlockOuter>;
}

export default SiteInfo;